// extracted by mini-css-extract-plugin
export default {"buttonLeft":"H8UPxr","buttonRight":"dQMNO5","label":"LZBSrK","buttonGroup":"pIRK3h","mobileButton":"wJDUdY"};